var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('p',{staticClass:"body-1 mb-3"},[_c('stemble-latex',{staticStyle:{"white-space":"pre-wrap"},attrs:{"content":_vm.text,"task-state":_vm.taskState}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }